import styled from '../../utils/styled';
import { mediaBreakpointDownSM } from '../../../constants/style-constants';

export const NavigationItemContainer = styled.div({
  width: '100%',
  borderTop: '1px solid #343434',
  display: 'flex',
  fontSize: '18px',
  transition: 'background-color 0.3s linear',
  '&:hover': {
    backgroundColor: '#383838',
  },
});

export const Item = styled.div({
  fontFamily: 'Spyscapetwo webfont, sans-serif',
  fontWeight: '300',
  display: 'flex',
  alignItems: 'center',
  fontSize: '18px',
  [mediaBreakpointDownSM]: {
    fontSize: '16px',
  },
});

export const ArrowLeft = styled.img({
  paddingRight: '15px',
});

export const NavigationItemLink = styled.a(({ active }) => ({
  color: active ? '#4ec3f7' : '#fff',
  width: '100%',
  padding: '20px 10px',
  textTransform: 'uppercase',
}));
